import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f2711856"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-bar" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"company\" data-v-f2711856><div class=\"logo\" data-v-f2711856><img src=\"/assets/logo.png\" data-v-f2711856></div><div class=\"title-c\" data-v-f2711856><span class=\"company-name\" data-v-f2711856>同村科技</span><span data-v-f2711856>SameVillage</span></div></div>", 1)
const _hoisted_3 = { class: "menu" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-store" }, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://www.samevillage.com:20443/login"
  }, "应用商城")
], -1))

import { onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleBar',
  setup(__props) {

let topSrcoll = ref<boolean>(false);
let scrollTop = ref<number>(0);

onMounted(() => {
  window.addEventListener('scroll', onWindowSrcoll)
})

watch(scrollTop, (newValue, oldValue) => {
  if (newValue > 100) {
    if (newValue > oldValue) {
      topSrcoll.value = true
    } else {
      topSrcoll.value = false
    }
  }
})

function onWindowSrcoll() {
  scrollTop.value = scrollTop.value = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
}


return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["title-container", {'scroll' : _unref(topSrcoll)}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_menu, {
          router: "",
          "default-active": _unref(useRoute)().path,
          mode: "horizontal",
          "text-color": "#000",
          "active-text-color": "#086bf6",
          style: {"height":"100%"},
          "popper-offset": 0
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item, { index: "/" }, {
              default: _withCtx(() => [
                _createTextVNode("首页")
              ]),
              _: 1
            }),
            _createVNode(_component_el_sub_menu, { "popper-class": "poper" }, {
              title: _withCtx(() => [
                _createTextVNode("产品")
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "/aboutXf" }, {
                  default: _withCtx(() => [
                    _createTextVNode("先锋云信")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/aboutLiveMeeting" }, {
                  default: _withCtx(() => [
                    _createTextVNode("视频会议")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/try" }, {
              default: _withCtx(() => [
                _createTextVNode("试用")
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/price" }, {
              default: _withCtx(() => [
                _createTextVNode("价格")
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/solution" }, {
              default: _withCtx(() => [
                _createTextVNode("解决方案")
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/download" }, {
              default: _withCtx(() => [
                _createTextVNode("下载中心")
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/contact" }, {
              default: _withCtx(() => [
                _createTextVNode("联系我们")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["default-active"])
      ]),
      _hoisted_4
    ])
  ], 2))
}
}

})